import Vue from 'vue';
import VueRouter, {NavigationGuardNext, Route, RouteConfig} from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

export const routes: RouteConfig[] = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
    },
    {
        path: '/premiere-connexion',
        name: 'FirstConnection',
        component: () => import('@/views/profile/FirstConnection.vue'),
    },
    {
        path: '/erreur',
        name: 'NoStudent',
        component: () => import('@/views/profile/ProfileCreationError.vue'),
    },
    {
        path: '',
        component: () => import('@/views/AppTemplate.vue'),
        children: [
            {
                path: '/annonces/nouvelle',
                name: 'AdvertCreation',
                component: () => import('@/views/advert/Creation.vue'),
            },
            {
                path: '/annonces/edition/:advertId',
                name: 'AdvertUpdate',
                props: true,
                component: () => import('@/views/advert/Creation.vue'),
            },
            {
                path: '/annonces/:advertId',
                name: 'AdvertDetail',
                props: true,
                component: () => import('@/views/advert/Detail.vue'),
            },
            {
                path: '/annonces',
                name: 'AdvertList',
                component: () => import('@/views/advert/List.vue'),
            },
            {
                path: '/mes-annonces',
                name: 'PersonalAdvertList',
                component: () => import('@/views/advert/List.vue'),
            },
            {
                path: '/favoris',
                name: 'FavoriteList',
                component: () => import('@/views/advert/List.vue'),
            },
            {
                path: '/page-perso',
                name: 'DefaultList',
                component: () => import('@/views/advert/List.vue'),
            },
            {
                path: '/options-page-personnalisee',
                name: 'DefaultSettings',
                component: () => import('@/views/profile/DefaultSettings.vue'),
            },
            {
                path: '/messages',
                name: 'MessageList',
                component: () => import('@/views/message/List.vue'),
            },
            {
                path: '/messages/admin/utilisateur',
                name: 'MessageDetailAdmin',
                component: () => import('@/views/message/Detail.vue'),
            },
            {
                path: '/messages/annonce/:advertId/utilisateur/:userId',
                name: 'MessageDetail',
                component: () => import('@/views/message/Detail.vue'),
            },
            {
                path: '/profil',
                name: 'ProfileDetail',
                component: () => import('@/views/profile/Detail.vue'),
            },
            {
                path: '/profil/notifications',
                name: 'Notifications',
                component: () => import('@/views/profile/Notifications.vue'),
            },
            {
                path: '/profil/:authorId',
                name: 'AuthorDetail',
                component: () => import('@/views/profile/AuthorDetail.vue'),
            },
            {
                path: '/recherches/resultats',
                name: 'SearchResult',
                component: () => import('@/views/advert/SearchResult.vue'),
            },
            {
                path: '/admin/nouvelle-categorie',
                name: 'AdminCategories',
                component: () => import('@/views/admin/AdminCategory.vue'),
            },
            {
                path: '/admin/messages',
                name: 'AdminMessages',
                component: () => import('@/views/admin/AdminMessages.vue'),
            },
            {
                path: '/admin/stats',
                name: 'AdminStats',
                component: () => import('@/views/admin/AdminStats.vue'),
            },
        ],
    },
    {
        path: '*',
        redirect: {name: 'Home'},
    },
];

const router = new VueRouter({
    mode: 'history',
    base: '', //process.env.VUE_APP_BASE_URL_FRONT
    routes,
});

router.beforeEach((to: Route, from: Route, next: NavigationGuardNext) => {
    if (to.name === 'NoStudent') {
        next();
    } else {
        const route = localStorage.getItem('to');

        if (route && to.name !== 'FirstConnection') {
            localStorage.removeItem('to');
            next(JSON.parse(route));
        } else {
            Promise.all([
                store.dispatch('loadProfile'),
                store.dispatch('loadCategories'),
            ])
                   .then((response) => {
                       if (response[0]) {
                           const {termsAccepted, gdprAccepted} = response[0];
                           if ((!termsAccepted || !gdprAccepted) && to.name !== 'FirstConnection') {
                               localStorage.setItem('to', JSON.stringify(to));
                               next({name: 'FirstConnection'});
                           } else {
                               next();
                           }
                       } else {
                           if (to.name?.match(/Admin/) !== null && !store.getters.isAdmin) {
                               next({name: 'AdvertList'});
                           } else {
                               next();
                           }
                       }
                   })
                   .catch((error) => {
                       if (to.name === 'FirstConnection') {
                           next();
                       } else if (error.response.data.code === 'user_not_found' && from.name !== 'FirstConnection') {
                           localStorage.setItem('to', JSON.stringify(to));
                           next({name: 'FirstConnection'});
                       } else {
                           next();
                       }
                   });
        }
    }
});

export default router;
